"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpResourceMeta = void 0;
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const gettext_1 = require("@integro/gettext");
const resource_meta_html_1 = __importDefault(require("./resource-meta.html"));
require("./styles.scss");
let ItpResourceMeta = class ItpResourceMeta extends vue_1.default {
    msgCreated;
    msgLastModified;
    item;
    noTooltip;
    data() {
        return {
            msgCreated: (0, gettext_1.pgettext)('ItpResourceMeta', 'Created'),
            msgLastModified: (0, gettext_1.pgettext)('ItpResourceMeta', 'Last modified')
        };
    }
    get hasTooltip() {
        return !this.noTooltip;
    }
    get tooltipText() {
        if (this.hasTooltip && this.$options.filters) {
            return this.$options.filters.datetime(this.dateToDisplay);
        }
    }
    get createdBy() {
        return (this.item.created_by &&
            this.$app.users.getUserDisplayName(this.item.created_by));
    }
    get createdAt() {
        return this.item.created_at;
    }
    get updatedBy() {
        return (this.item.updated_by &&
            this.$app.users.getUserDisplayName(this.item.updated_by));
    }
    get updatedAt() {
        return this.item.updated_at;
    }
    get textToDisplay() {
        return this.item.updated_at ? this.msgLastModified : this.msgCreated;
    }
    get dateToDisplay() {
        return this.item.updated_at || this.item.created_at;
    }
    get userToDisplay() {
        return this.item.updated_by || this.item.created_by;
    }
};
exports.ItpResourceMeta = ItpResourceMeta;
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Object)
], ItpResourceMeta.prototype, "item", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpResourceMeta.prototype, "noTooltip", void 0);
exports.ItpResourceMeta = ItpResourceMeta = __decorate([
    (0, vue_property_decorator_1.Component)({
        template: resource_meta_html_1.default,
        inject: {
            componentContext: 'componentContext'
        }
    })
], ItpResourceMeta);
//# sourceMappingURL=resource-meta.js.map